<template>
  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="用户房产名称">
          <el-input placeholder="请输入用户房产名称" v-model="formInline.search"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加用户房产</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="user_id" label="用户id"></el-table-column>
            <el-table-column prop="real_estate_name" label="房产名称"></el-table-column>
            <el-table-column prop="room_number" label="房号"></el-table-column>
            <el-table-column prop="owner_name" label="业主"></el-table-column>
            <el-table-column prop="owner_phone" label="手机号"></el-table-column>
            <el-table-column prop="sort" label="排序"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column prop="status" label="状态" width="100">
              <template slot-scope="scope">
                <el-tag :type="getStatusType(scope.row.status)">
                  {{ getStatusText(scope.row.status) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="150">
              <template slot-scope="scope">
                <el-button @click="auditClick(scope.row)" type="text" size="small" v-if="scope.row.status === 0">审核</el-button>
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add" @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :fc_user_id="fc_user_id" v-if="open_edit" @close="closeEdit"></Edit>

    <!-- 审核对话框 -->
    <el-dialog
      title="审核用户房产"
      :visible.sync="auditDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form :model="auditForm" label-width="80px">
        <el-form-item label="审核结果">
          <el-radio-group v-model="auditForm.status">
            <el-radio :label="1">审核通过</el-radio>
            <el-radio :label="2">审核不通过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审核备注" v-if="auditForm.status === 2">
          <el-input
            type="textarea"
            :rows="3"
            v-model="auditForm.audit_remark"
            placeholder="请输入审核不通过的原因"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="auditDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAudit" :loading="auditLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Fc_userApi from '@/api/fc_user.js';
import Add from './part/add.vue';
import Edit from './part/edit.vue';

export default {
  components: {
    Add,
    Edit,
  },
  data() {
    return {
      loading: true,
      tableData: [],
      pageSize: 20,
      totalDataNumber: 0,
      curPage: 1,
      form: {},
      formInline: {
        search: ""
      },
      open_add: false,
      open_edit: false,
      fc_user_id: "",
      
      // 审核相关数据
      auditDialogVisible: false,
      auditLoading: false,
      auditForm: {
        fc_user_id: "",
        status: 1,
        audit_remark: ""
      }
    };
  },
  created() {
    this.getTableList();
  },
  methods: {
    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        0: '待审核',
        1: '审核通过',
        2: '审核不通过'
      };
      return statusMap[status] || '未知状态';
    },
    
    // 获取状态标签类型
    getStatusType(status) {
      const typeMap = {
        0: 'warning',
        1: 'success',
        2: 'danger'
      };
      return typeMap[status] || 'info';
    },
    
    /*关闭添加*/
    closeAdd(e) {
      this.open_add = false;
      this.getTableList();
    },
    closeEdit(e) {
      this.open_edit = false;
      this.getTableList();
    },
    getData() {
      this.getTableList();
    },
    
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      Fc_userApi.list(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*添加任务*/
    addClick() {
      this.open_add = true;
    },

    /*编辑活动*/
    editClick(row) {
      this.fc_user_id = row.fc_user_id;
      this.open_edit = true;
    },

    /*审核点击*/
    auditClick(row) {
      this.auditForm = {
        fc_user_id: row.fc_user_id,
        status: 1,
        audit_remark: ""
      };
      this.auditDialogVisible = true;
    },

    /*提交审核*/
    submitAudit() {
      let self = this;
      self.auditLoading = true;
      
      Fc_userApi.audit(this.auditForm, true)
        .then(data => {
          self.auditLoading = false;
          if (data.code == 1) {
            self.$message({
              message: '审核成功',
              type: 'success'
            });
            self.auditDialogVisible = false;
            self.getTableList();
          } else {
            self.$message.error(data.msg || '审核失败');
          }
        })
        .catch(error => {
          self.auditLoading = false;
          self.$message.error('审核失败');
        });
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Fc_userApi.del({ fc_user_id: row.fc_user_id }, true)
          .then(data => {
            if (data.code == 1) {
              self.$message({ message: '删除成功', type: 'success' });
              this.getTableList();
            } else {
              self.$message.error('删除失败');
            }
          })
          .catch(error => {
            self.$message.error('删除失败');
          });
      }).catch(() => {});
    }
  }
};
</script>

<style>
/* 可以添加一些自定义样式 */
</style>


// WEBPACK FOOTER //
// src/views/plus/fc_user/index/index.vue